import Vue from 'vue'
import EventBus from '../_event-bus'
import { $$ } from '../_utils'

Vue.component('vue-modal-added-to-cart', {
  template: '#vue-modal-added-to-cart-template',
  data() {
    return {
      cartLink: `${process.env.BASE_URL}${process.env.CART_URL}`,
      isOpen: false,
      modal: {},
    }
  },
  methods: {
    closeModal() {
      this.isOpen = false
      this.modal = {}
    },
  },
  created() {
    EventBus.$on('open-modal-added-to-cart', ({ modal }) => {
      this.isOpen = true
      this.modal = modal
    })
  },
})

window.onload = function () {
  const modals = $$('#vue-modal-added-to-cart-wrapper')
  modals.forEach(el => new Vue({ el }))
}
